import AwsConfig from '../../Config/AwsConfig'
import GetmoviesAppInfoConfigService from '../../Services/Queries/GetmoviesAppInfoConfigService'
import { platforms } from '../Data/StaticPersonandMoviedata'
import { castformatdata, castformatdatate } from './castrender'
import GetFormattedDate from './getFormattedDate'
import rendercrewte from './rendercrewte'
import rendercrew from './rendermcrew'

export const movieDataInput = (movieDataExists, posterUrl, ottArray) => {
  const movieinputData = {
    based: extractInfo(movieDataExists, 'basedOn_En'),
    basedte: extractInfo(movieDataExists, 'basedOn_Te'),
    Bio: getInfo({
      data: movieDataExists,
      propertyName: 'about',
      language: 'En',
    }),
    biote: getInfo({
      data: movieDataExists,
      propertyName: 'about',
      language: 'Te',
    }),
    genRe: getInfo({
      data: movieDataExists,
      propertyName: 'genre',
      language: 'En',
      isArray: true,
    }),
    movieName: getInfo({
      data: movieDataExists,
      propertyName: 'title',
      language: 'En',
    }),
    movieNamete: getInfo({
      data: movieDataExists,
      propertyName: 'title',
      language: 'Te',
    }),
    Moviedirector: renderCrewInfo(movieDataExists, 'Director'),
    Moviedirectorte: renderCrewInfoTe(movieDataExists, 'Director'),
    MovieCimematographer: renderCrewInfo(movieDataExists, 'Cinematographer'),
    MovieCimematographerTelugu: renderCrewInfoTe(movieDataExists, 'Cinematographer'),
    Moviemusicby: renderCrewInfo(movieDataExists, 'Musician'),
    Moviemusicbyte: renderCrewInfoTe(movieDataExists, 'Musician'),
    MovieEditor: renderCrewInfo(movieDataExists, 'Editor'),
    MovieEditorte: renderCrewInfoTe(movieDataExists, 'Editor'),
    Moviewritter: renderCrewInfo(movieDataExists, 'Writer'),
    MovieScreenPlay: renderCrewInfo(movieDataExists, 'Screenplay'),
    MovieScreenPlayTelugu: renderCrewInfoTe(movieDataExists, 'Screenplay'),
    story: renderCrewInfo(movieDataExists, 'Story'),
    storyte: renderCrewInfoTe(movieDataExists, 'Story'),
    MovieDialoge: renderCrewInfo(movieDataExists, 'Dialogue Writer'),
    MovieDialogete: renderCrewInfoTe(movieDataExists, 'Dialogue Writer'),
    MovieProductionCompany: splitAndTrim(movieDataExists.productionCompany_En),
    MovieProductionCompanyTelugu: splitAndTrim(movieDataExists.productionCompany_Te),
    MovieProducer: renderCrewInfo(movieDataExists, 'Producer'),
    MovieProducerTelugu: renderCrewInfoTe(movieDataExists, 'Producer'),
    country: movieDataExists.country || '',
    runTime: movieDataExists.runningTime || '',
    poster: posterUrl,
    ottDate: checkOTTUI(movieDataExists) ? '' : ottDate(movieDataExists),
    ottDateUi: checkOTTUI(movieDataExists),
    Moviecast: castformatdata(movieDataExists),
    Moviecastte: castformatdatate(movieDataExists),
    wikilink: movieDataExists.wikipediaLink || '',
    MovieDistibutor: splitAndTrim(movieDataExists.distributedBy_En),
    MovieDistibutorTelugu: splitAndTrim(movieDataExists.distributedBy_Te),
    collection: movieDataExists.boxOffice || '',
    Budget: movieDataExists.budget || '',
    releaseDate: movieDataExists.movieReleasedDate
      ? GetFormattedDate(parseInt(movieDataExists.movieReleasedDate || '0', 10))
      : '',
    releaseDateUi: movieDataExists.movieReleasedDateUI,
    imdb: ImdbRating(movieDataExists),
    restrit: movieDataExists.ageRestriction || '',
    Movielinks: ottArray[0],
    ott: ottArray[1],
    language1: getLanguageArray(movieDataExists.language),
    Moviewritterte: renderCrewInfoTe(movieDataExists, 'Writer'),
    MovieYouSayRating: movieYousayRating(movieDataExists),
    contentType: movieDataExists.contentType || '',
    noOfEpisodes: noOfEpisodes(movieDataExists),
    // MovieYouSayReviewUrl: getYouSayReviewUrl(movieDataExists, 'En'),
    // MovieYouSayReviewUrlTe: getYouSayReviewUrl(movieDataExists, 'Te'),
    GalleryImages: getGalleryImages(movieDataExists),
    GalleryVideos: getGalleryVideos(movieDataExists),
    popularMovie: popularMovieHandle(movieDataExists),
    GOAT: movieDataExists.GOAT || false,
    // movieReviewArticleTitleEn: movieDataExists.movieArticleReviewTitle_En || '',
    // movieReviewArticleTitleTe: movieDataExists.movieArticleReviewTitle_Te || '',
    originalLanguageTelugu: movieDataExists.originalLanguageTelugu || false,
    deleteFields:
      movieDataExists && movieDataExists.deleteFields
        ? movieDataExists.deleteFields.includes('ottReleasedDate')
        : false,
    movieAndOTTNewsUpdates: movieDataExists.movieAndOTTNewsUpdates
      ? movieDataExists.movieAndOTTNewsUpdates
      : [],
    internalComments: movieDataExists.internalComments || '',
    movieStatus: movieDataExists.movieStatus || 'MovieReleased',
    OTTStatus: OttStatus(movieDataExists),
    OTTPlatformsWithLangs: ottPlatformlanguages(movieDataExists),
    yousayArticleReviews: movieArticleReview(movieDataExists.yousayArticleReviews),
    sendTFIDBPN: movieDataExists.sendTFIDBPN || false,
    PNInfo: checKPNInfo(movieDataExists, posterUrl),
    // .PNInfo || {
    //   title_En: getInfo({
    //     data: movieDataExists,
    //     propertyName: 'title',
    //     language: 'En',
    //   }),
    //   title_Te: getInfo({
    //     data: movieDataExists,
    //     propertyName: 'title',
    //     language: 'Te',
    //   }),
    //   description_En: getInfo({
    //     data: movieDataExists,
    //     propertyName: 'about',
    //     language: 'En',
    //   }),
    //   description_Te: getInfo({
    //     data: movieDataExists,
    //     propertyName: 'about',
    //     language: 'Te',
    //   }),
    //   posterURL: posterUrl,
    // },
  }

  // console.log(movieinputData, 'movieinputData')
  return movieinputData
}

const checKPNInfo = movieDataExists => {
  // Helper function to get information or fallback to getInfo
  const getInfoOrDefault = (data, propertyName, language) =>
    (data && data.PNInfo && data.PNInfo[propertyName + '_' + language]) ||
    getInfo({
      data,
      propertyName,
      language,
    })

  // Extract or default values
  const titleEn =
    movieDataExists.PNInfo?.title_En || getInfoOrDefault(movieDataExists, 'title', 'En')
  const titleTe =
    movieDataExists.PNInfo?.title_Te || getInfoOrDefault(movieDataExists, 'title', 'Te')
  const descriptionEn =
    movieDataExists.PNInfo?.description_En || getInfoOrDefault(movieDataExists, 'about', 'En')
  const descriptionTe =
    movieDataExists.PNInfo?.description_Te || getInfoOrDefault(movieDataExists, 'about', 'Te')
  // const posterURL = movieDataExists.PNInfo?.posterURL || posterUrl

  // Return the extracted or default values
  return {
    title_En: titleEn,
    title_Te: titleTe,
    description_En: descriptionEn,
    description_Te: descriptionTe,
  }
}

const movieArticleReview = yousayArticleReviews =>
  yousayArticleReviews
    ? yousayArticleReviews[0]
    : {
        articleReviewTitle_En: '',
        articleReviewTitle_Te: '',
        articleReviewURL_En: '',
        articleReviewURL_Te: '',
        articleReviewDescription_En: '',
        articleReviewDescription_Te: '',
        articleReviewRating: '',
      }

const extractInfo = (data, propertyName) =>
  data[propertyName] ? data[propertyName].split(',') : []

const getInfo = ({ data, propertyName, language, isArray }) => {
  const property = `${propertyName}_${language}`
  if (isArray) {
    return data[property] ? data[property] : []
  }

  return data[property] ? data[property] : ''
}

const renderCrewInfo = (data, role) => rendercrew(data, role)
const renderCrewInfoTe = (data, role) => rendercrewte(data, role)

const splitAndTrim = str => (str ? str.split(',').map(item => item.trim()) : [])

const checkOTTUI = movieDataExists =>
  movieDataExists.ottReleasedDateUI === null
    ? false
    : movieDataExists.ottReleasedDateUI.includes('Streaming Soon')

const ottDate = movieDataExists =>
  movieDataExists.ottReleasedDate ? removeTrailingZeros(movieDataExists.ottReleasedDate) : ''

const ImdbRating = movieDataExists =>
  movieDataExists.yousayRating
    ? ''
    : parseFloat(movieDataExists.movieRatingAdminPanel || '0', 10) || ''

const noOfEpisodes = movieDataExists => movieDataExists.noOfEpisodes || ''

const movieYousayRating = movieDataExists => movieDataExists.yousayRating || ''

// const getYouSayReviewUrl = (movieDataExists, language) =>
//   movieDataExists[`yousayMovieReviewURL_${language}`] || ''

const getLanguageArray = languageString =>
  languageString ? languageString.split(',').map(e => ({ label: e, value: e })) : []

const ottPlatformlanguages = movieDataExists => movieDataExists.OTTPlatformsWithLangs || []
const getGalleryVideos = movieDataExists => {
  const cdnurl = AwsConfig.movieCdnUrl
  if (movieDataExists.galleryVideos) {
    const galleryVideos = movieDataExists.galleryVideos.map(e => ({
      path: e.path.includes('public/movies/videos') ? cdnurl + e.path : e.path,
      title: e.title,
      thumbnail: e.thumbnail,
    }))
    return galleryVideos.length > 0 ? galleryVideos : []
  }

  return []
}

const getGalleryImages = movieDataExists => {
  const cdnurl = AwsConfig.movieCdnUrl
  if (movieDataExists.galleryImages) {
    const galleryImages = movieDataExists.galleryImages.map(e => ({
      path: cdnurl + e.path,
      title: e.title,
    }))
    return galleryImages.length > 0 ? galleryImages : []
  }

  return []
}

const OttStatus = movieDataExists => movieDataExists.OTTStatus || ''
const popularMovieHandle = movieDataExists =>
  (movieDataExists && movieDataExists.popularMovie) || false

export const ottLink = async movieDataExists => {
  const link = []
  const ott = []
  const formattedOttReleaseDate = movieDataExists.ottReleasedDate
    ? GetFormattedDate(removeTrailingZeros(movieDataExists.ottReleasedDate))
    : ''
  console.log('=======================================')
  const appInfoData = await GetmoviesAppInfoConfigService()
  const ottData = appInfoData.getMoviesAppInfoConfig.ottList.reduce((platformMap, platform) => {
    const { label, url } = platform
    platformMap[label] = { label, value: url }
    return platformMap
  }, {})
  console.log(ottData, 'ottData====')
  const processPlatform = ({ key, label }) => {
    const ottInfo = ottData[label]
    link.push({
      link: movieDataExists[key] ? movieDataExists[key] : '',
      ottDate: formattedOttReleaseDate,
    })
    ott.push({ label: ottInfo.label, value: ottInfo.value })
  }

  const mapOTTToPlatform = (ott, platforms) => {
    const platform = platforms.find(item => item.label === ott)
    return platform ? platform : null
  }

  const platfomsfromService = movieDataExists.ottPlatform ? movieDataExists.ottPlatform : []
  // Map each OTT platform to its corresponding value
  const mappedPlatforms = platfomsfromService.map(ott => mapOTTToPlatform(ott, platforms))
  mappedPlatforms.forEach(processPlatform)

  return { link, ott }
}

export function removeTrailingZeros(number) {
  const numberString = number.toString()
  const trimmedString = numberString.replace(/0+$/, '')
  let paddedString = ''
  if (trimmedString.length === 7) {
    paddedString = trimmedString + '0'
  } else if (trimmedString.length === 5) {
    paddedString = trimmedString + '0'
  } else {
    const minLength = Math.max(trimmedString.length, 4)
    paddedString = trimmedString.padEnd(minLength, '0')
  }

  return Number(paddedString)
}
